module.exports = __webpack_public_path__ + "static/media/4.d4e358d1.png";